export default function initializeDeliveryInfo() {
    let deliveryInfo = document.querySelectorAll('.delivery-info');

    if (!deliveryInfo) {
        return;
    }

    deliveryInfo.forEach(function (item) {
        let deliveryInfoContentPopup = item.querySelector('.delivery-info__content--popup');
        let deliveryInfoContentTooltip = item.querySelector('.delivery-info__content--tooltip');
        let deliveryInfoClose = item.querySelector('.delivery-info__close');


// wyświetlanie popupa po kliknięciu na ikonę zapytania dla urządzeń mobilnych i tabletów
        if (deliveryInfoContentPopup) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                if(window.innerWidth > 768) {
                    return;
                }
                // jeśli klikamy na ikonę zamykania lub na jej dziecko, to nie otwieramy popupa
                if (e.target.classList.contains('delivery-info__close') || e.target.parentElement.classList.contains('delivery-info__close')) {
                    return;
                }
                deliveryInfoContentTooltip.classList.remove('delivery-info__content--visible');
                deliveryInfoContentPopup.classList.add('delivery-info__content--visible');
            });
            deliveryInfoClose.addEventListener('click', function (e) {
                e.preventDefault();
                deliveryInfoContentPopup.classList.remove('delivery-info__content--visible');
            });
        }

            // wyświetlanie tooltipa po najechaniu na ikonę zapytania
        if(deliveryInfoContentTooltip) {
            item.addEventListener('mouseenter', function (e) {
                if(window.innerWidth <= 768) {
                    return;
                }
                if(deliveryInfoContentPopup.classList.contains('delivery-info__content--visible')) {
                    return;
                }
                e.preventDefault();
                deliveryInfoContentTooltip.classList.add('delivery-info__content--visible');
            });
            item.addEventListener('mouseleave', function (e) {
                e.preventDefault();
                deliveryInfoContentTooltip.classList.remove('delivery-info__content--visible');
            });
        }
    });
}
